export default __webpack_public_path__ + "static/media/education-img-cover-cutting.234466b7.png";